module.exports = __webpack_public_path__ + "static/media/ind-logo.95eb72c1.png";